import { IntlShape } from "react-intl";

import LeaderboardMetricFieldName from "@mapmycustomers/shared/enum/fieldModel/LeaderboardMetricFieldName";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import localSettings from "@app/config/LocalSettings";
import formatSeconds from "@app/scene/dashboard/utils/formatSeconds";

const formatMetricValue = (intl: IntlShape, field: IField, value: number): number | string => {
  if (!value) {
    return "—";
  }
  if (
    field.name === LeaderboardMetricFieldName.NEW_PIPELINE_REVENUE ||
    field.name === LeaderboardMetricFieldName.REVENUE_CLOSED_LOST ||
    field.name === LeaderboardMetricFieldName.REVENUE_CLOSED_WON
  ) {
    return intl.formatNumber(value, {
      currency: localSettings.getCurrencyCode(),
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: "currency",
    });
  } else if (
    field.name === LeaderboardMetricFieldName.TOTAL_FACE_TIME ||
    field.name === LeaderboardMetricFieldName.VERIFIED_FACE_TIME
  ) {
    return formatSeconds(intl, value);
  } else {
    return value;
  }
};

export default formatMetricValue;
